import { render, staticRenderFns } from "./areaStatic.vue?vue&type=template&id=54312e8e&scoped=true&"
import script from "./areaStatic.vue?vue&type=script&lang=js&"
export * from "./areaStatic.vue?vue&type=script&lang=js&"
import style0 from "./areaStatic.vue?vue&type=style&index=0&id=54312e8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54312e8e",
  null
  
)

export default component.exports